export default __webpack_public_path__ + "static/icons-6b66151eb8bf3ca81411c83fb80cee40.svg";